export default "__VITE_ASSET__DscjSfrw__"